module.exports = "js/webpack/7f7ebe1e9d6b4b01543498d12568eb3b.svg";